import React from 'react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

import type { ItemFila } from 'volto-ministerio-publico-federal/helpers/Notificacoes';
import EtapasFluxo from './EtapasFluxo';
import SolicitarNacional from './SolicitarNacional';

type Props = {
  items: ItemFila[];
  loading: boolean;
  error: unknown;
  onAbrir?: () => void;
};

/**
 * Notícias e páginas que estão esperando uma ação sua (`@minha-fila`). As
 * publicadas localmente vêm como sugestão (`opcional`), com o botão de
 * solicitar a publicação nacional.
 */
const MinhaFila = ({ items, loading, error, onAbrir }: Props) => {
  if (loading && items.length === 0) {
    return <p className="mpf-notificacoes__vazio">Carregando…</p>;
  }
  if (error) {
    return (
      <p className="mpf-notificacoes__vazio" role="alert">
        Não foi possível carregar sua fila de trabalho.
      </p>
    );
  }
  if (items.length === 0) {
    return <p className="mpf-notificacoes__vazio">Nada esperando por você.</p>;
  }
  return (
    <ul className="mpf-notificacoes__lista">
      {items.map((item) => (
        <li
          key={item.uid}
          className="mpf-notificacoes__item mpf-notificacoes__item--acao"
        >
          <div className="mpf-notificacoes__corpo">
            <UniversalLink
              href={flattenToAppURL(item['@id'])}
              className="mpf-notificacoes__titulo"
              onClick={onAbrir}
            >
              {item.title}
            </UniversalLink>
            <p className="mpf-notificacoes__descricao">
              {item.acao}
              {' · '}
              <span className="mpf-notificacoes__estado">
                {item.review_state_title}
              </span>
            </p>
            <EtapasFluxo
              estado={item.review_state}
              fluxo={item.fluxo}
              compacto={false}
              proximaEtapa={
                item.opcional
                  ? {
                      rotulo: 'Publicação nacional',
                      acao: (
                        <SolicitarNacional
                          url={item['@id']}
                          titulo={item.title}
                          onClick={onAbrir}
                        />
                      ),
                    }
                  : undefined
              }
            />
          </div>
        </li>
      ))}
    </ul>
  );
};

export default MinhaFila;
